import { API } from '../../api'
import { Cookies } from 'react-cookie'
import { jwtDecode } from 'jwt-decode'

const cookies = new Cookies()

export const AuthService = {
  login: async (username, password) => {
    const res = await API.post('/login', { username, password })
    if (!res.data) return null

    console.warn(`User logged in!`)

    return res.data
  },
  getUserProfile: async () => {
    if (!isInUserEnvironment) return null
    const userRes = await API.get('/profile')

    if (!userRes.data) return null

    return userRes.data
  },
  getAccessToken: () => {
    return cookies.get('jwt_token')
  },
  logout: () => {
    clearUserCookies()
    window.location.replace('/')
    console.warn(`User logged out!`)
  },
  signinRedirect: () => {
    if (!isInUserEnvironment()) return
    setRedirectUri(window.location.pathname + window.location.search)
    window.location.replace('/signin-oidc/')
  }
}

function checkIfAccessTokenIsExpired(expiresAt) {
  let expiresAtTime = expiresAt * 1000 // ExpiresAt * 1000 gives the expiry time of the token

  return expiresAtTime < new Date().getTime()
}

function setRedirectUri(url) {
  localStorage.setItem('redirectUri', !url.includes('signin-oidc') ? url : '/')
}

export function clearUserCookies() {
  cookies.remove('auth_type')
  cookies.remove('_user')
  cookies.remove('jwt_token')
  console.warn('User cookies cleared!')
}

export function setUserCookies(data) {
  const decoded = jwtDecode(data?.message?.user?.token)
  cookies.set('auth_type', 'Bearer')

  cookies.set('_user', data?.message?.user, {
    expires: new Date(decoded?.time * 1000)
  })

  cookies.set('jwt_token', data?.message?.user?.token, {
    expires: new Date(decoded?.time * 1000)
  })

  console.warn('User cookies set!')
}

export function getRefreshToken() {
  return cookies.get('_user')?.refreshToken
}

function isInUserEnvironment() {
  return typeof window !== 'undefined' && window !== null
}
